<div class="salesVarContainer">
  <div class="table-container">
    <div class="arrowsContainer">
      <div class="button" [ngClass]="{'selected': selectedFilter === 'priceAsc' || selectedFilter === 'qtyAsc' }" (click)="setToUp()">
        <span class="arrowUp">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" class="bi bi-chevron-up" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
          </svg>
        </span>
      </div>
      <div class="button" [ngClass]="{'selected': selectedFilter === 'priceDesc' || selectedFilter === 'qtyDesc' }" (click)="setToDown()">
        <span class="arrowDown">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" class="bi bi-chevron-down" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
          </svg>
        </span>
      </div>
    </div>
    <div class="tableHeaders">
      <div class="count"></div>
      <div class="product">Product</div>
      <div class="sales" (click)="setToSales()">Sales</div>
      <div class="qty" (click)="setByQty()" [ngClass]="{'negative': selectedFilter === 'qtyDesc', 'positive': selectedFilter === 'qtyAsc' }">
        <span *ngIf="selectedFilter == 'qtyAsc'">△</span>
        <span *ngIf="selectedFilter == 'qtyDesc'">▽</span>
        <span>Q</span>
      </div>
      <div class="price" (click)="setByPrice()" [ngClass]="{'negative': selectedFilter === 'priceDesc', 'positive': selectedFilter === 'priceAsc' }">
        <span *ngIf="selectedFilter == 'priceAsc'">△</span>
        <span *ngIf="selectedFilter == 'priceDesc'">▽</span>
        <span>P</span>
      </div>
    </div>
    <div
      *ngFor="
        let item of data.graph.data[currentBUIndex].table[selectedSliderValue][
          selectedFilter
        ];
        let index = index;
        trackBy: trackByIndex
      "
      class="table-row"
    >
        <div class="count">{{ index + 1 }}</div>
        <div class="product">{{ item.name }}</div>
        <div class="sales">{{ item.sales }}</div>
        <div class="qty" [ngClass]="{'negative': selectedFilter === 'qtyDesc', 'positive': selectedFilter === 'qtyAsc' }">{{ item.qty }}</div>
        <div class="price" [ngClass]="{'negative': selectedFilter === 'priceDesc', 'positive': selectedFilter === 'priceAsc' }">{{ item.price }}</div>
    </div>
  </div>
  <div class="slider-container">
    <echarts
      [options]="chartOptionsSlider"
      (chartInit)="onChartInitSlider($event)"
      [autoResize]="false"
      class="chart-container"
    >
    </echarts>
  </div>
</div>
